// extracted by mini-css-extract-plugin
export default {"button":"button-979d","inline":"inline-711b"};